/*    
<summary>
   This is a common component that shows SVG image of no data.
   Developer:Aashish Singh , Created Date:08-July-2025
</summary>
*/
import React from "react";

const DisableAbortIconSVG: React.FC = () => {
  return (
    <svg
      id="Icons"
      height="20"
      viewBox="0 0 60 60"
      width="20"
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
    >
      <path d="m43 39a2 2 0 0 0 -2 2c0 1.648 1.21 5.494 2 5.979.79-.485 2-4.331 2-5.979a2 2 0 0 0 -2-2z" />
      <path d="m2.012 32.763a2.013 2.013 0 0 0 1.762 2.224 12.752 12.752 0 0 1 5 1.689 7.465 7.465 0 0 1 3.444 3.857 15.652 15.652 0 0 0 2.979 4.4 17.511 17.511 0 0 0 2.891 2.543c2.789 2.168 3.589 6.961 3.821 9.629a.988.988 0 0 0 .994.9h4.2a5.048 5.048 0 0 1 -.491-.734 4.926 4.926 0 0 1 .236-5.123l11.752-17.806a5.148 5.148 0 0 1 1.4-1.421v-18.921a2 2 0 0 0 -4 0v15a1 1 0 0 1 -2 0v-20a2 2 0 0 0 -4 0v19a1 1 0 0 1 -2 0v-24a2 2 0 0 0 -4 0v23a1 1 0 0 1 -2 0v-18a2 2 0 0 0 -4 0l-.01 23a1.991 1.991 0 0 1 -3.07 1.682 19.409 19.409 0 0 0 -11.032-2.682 2.017 2.017 0 0 0 -1.876 1.763z" />
      <circle cx="43" cy="54" r="1" />
      <path d="m57.635 56.317a2.959 2.959 0 0 0 -.143-3.073l-11.756-17.8a3.314 3.314 0 0 0 -5.471 0l-11.757 17.8a2.959 2.959 0 0 0 -.143 3.073 3.205 3.205 0 0 0 2.879 1.683h23.512a3.205 3.205 0 0 0 2.879-1.683zm-14.635.683a3 3 0 1 1 3-3 3 3 0 0 1 -3 3zm0-8c-2.848 0-4-6.859-4-8a4 4 0 0 1 8 0c0 1.141-1.152 8-4 8z" />
    </svg>
  );
};

export default DisableAbortIconSVG;
